// extracted by mini-css-extract-plugin
module.exports = {"subrnd2":"subrnd2_subrnd2__ngj1n","back-btn":"subrnd2_back-btn__1vtOZ","subrnd2-img1":"subrnd2_subrnd2-img1__36S0y","subrnd2-img2":"subrnd2_subrnd2-img2__2wH4B"};